import { product } from './product.reducer';

export default {
  product
}